// extracted by mini-css-extract-plugin
export default {"aboveMaxCharacterCount":"CharacterCount__aboveMaxCharacterCount___e6MoJ"};